import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { ItemProps } from '../dropdown.types';

type SubTriggerProps = Omit<ItemProps, 'variant'>;

const SubTrigger = forwardRef<HTMLDivElement, SubTriggerProps>(
  (
    {
      iconLeft: IconLeft,
      iconRight: IconRight,
      children,
      size = 'default',
      destructive,
      className,
      asLink,
      checked,
      onSelect,
      shortcutHint,
      ...props
    },
    ref,
  ) => {
    const sharedStyles = cx(
      'relative flex w-full overflow-hidden cursor-pointer rounded-default bg-elevated gap-3 box-border items-center justify-between',
      'data-[disabled]:text-quaternary data-[disabled]:cursor-auto data-[disabled]:select-none data-[disabled]:hover:bg-transparent',
      'data-[state=open]:bg-(--dropdown-hover-bg)',
      'focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary',
      'focus:outline-none',
      {
        'hover:bg-(--dropdown-hover-bg) text-primary': !destructive,
        'hover:bg-error text-error': destructive,
        'px-3 py-2 text-body-2 h-9': size === 'default',
        'px-3 py-2 text-body-2 h-8': size === 'compact',
        'px-3 py-1 text-caption-2 h-7': size === 'tiny',
      },
      className,
    );

    return (
      <RadixDropdown.SubTrigger {...props} asChild>
        <div ref={ref} className={sharedStyles}>
          {IconLeft && <IconLeft color={destructive ? 'error' : undefined} />}
          <div className="flex items-center w-full truncate text-decoration-none">{children}</div>
          {IconRight && <IconRight className="ml-auto" color={destructive ? 'error' : undefined} />}
        </div>
      </RadixDropdown.SubTrigger>
    );
  },
);

export default SubTrigger;
